import React from 'react';

import './FormattedNumberCell.scss';

export interface FormattedNumberCellProps {
  getValue: () => number | null;
}

const formatter = Intl.NumberFormat('en-US');

const FormattedNumberCell = ({ getValue }: FormattedNumberCellProps) => {
  const value = getValue();
  const noValue = value === null || value === undefined;

  return (
    <span className={`enkrateia-formatted-number-cell ${noValue ? 'no-value' : ''}`}>
      {noValue ? '-' : formatter.format(value)}
    </span>
  );
};

export default FormattedNumberCell;
